import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.tsx';

/** Blank screen while the session check is in flight — no login flash. */
function Pending() {
  return <div className="screen" />;
}

export function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Pending />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}

/**
 * The upload screen is admin-only and reached by direct URL — the design has no
 * nav entry point for it. Non-admins are sent back to the list, not shown a 403.
 */
export function RequireAdmin() {
  const { user, loading } = useAuth();

  if (loading) return <Pending />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
